import React from 'react';
import { toast as _toast } from 'react-toastify';
import { Translate } from "react-localize-redux";

export const toastTypes = {
  DEFAULT: 'default',
  ERROR: 'error',
  INFO: 'info',
  SUCCESS: 'success',
};

const _toasts = {
  default: _toast,
  error: _toast.error,
  info: _toast.info,
  success: _toast.success,
};

export const toaster = (message, type = 'default') => {
  _toasts[type](
    <React.Fragment>
      <Translate id={message} />
    </React.Fragment>,
  );
};

export default toaster;



// WEBPACK FOOTER //
// ./src/components/Toasts/toaster.jsx